<template>
  <div>
    <!-- <SideMenu /> -->
    <div class="main-content-wrap sidenav-open d-flex flex-column pb-4">
      <div
        class="main-header pl-4"
        style="z-index: 60; align-content: space-around;"
      >
        <div class="row">
          <div
            style="align-self: center;"
            class="logo col-md-1 col-lg-1 col-12 py-0"
          >
            <div
              class="dropdown animate__animated animate__fadeIn"
              style="font-size: 120%;"
            >
              <i
                @click="$router.push({ name: 'Onboarding' })"
                style="cursor: pointer; position: relative; top: 2px; color: #069;"
                class="fal fa-arrow-alt-circle-left mr-1.can-candidate-name"
              ></i>
              <span class="ml-2" style="top: 4%; position: relative;"
                >Candidates</span
              >
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="dropdown animate__animated animate__fadeIn d-inline-block">
          <button
            type="button"
            class="btn btn-success m-1 btn-raised ripple"
            @click="triggerOnboardingLoading ? null : trigger_onboarding()"
            style="background: linear-gradient(45deg, #28a745, #20c997); border: none; box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3); transition: all 0.3s ease;"
            onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(40, 167, 69, 0.4)'"
            onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(40, 167, 69, 0.3)'"
          >
            <i class="fal fa-play mr-2"></i>{{ triggerOnboardingTxt }}
            <v-icon
              :style="
                !triggerOnboardingLoading
                  ? 'display: none'
                  : 'font-size: 16px; color: #fff; padding: 0px 10px;'
              "
            >
              fal fa-circle-notch fa-spin
            </v-icon>
          </button>
          <button
            type="button"
            class="btn btn-info m-1 btn-raised ripple"
            @click="schedule_interview_dialog = true"
            style="background: linear-gradient(45deg, #17a2b8, #138496); border: none; box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3); transition: all 0.3s ease;"
            onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(23, 162, 184, 0.4)'"
            onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(23, 162, 184, 0.3)'"
          >
            <i class="fal fa-calendar-plus mr-2"></i>Schedule Interview
          </button>

          <!-- Dropdown for managing scheduled interviews -->
          <button
            type="button"
            class="btn btn-secondary m-1 dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style="background: linear-gradient(45deg, #6c757d, #5a6268); border: none; box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);"
          >
            <i class="fal fa-calendar-check mr-2"></i>Manage Interviews
          </button>
          <div
            class="dropdown-menu dropdown-menu-right"
            style="max-height: 400px; overflow-y: auto; min-width: 350px;"
          >
            <h6 class="dropdown-header">Scheduled Interviews</h6>
            <div
              v-if="scheduled_interviews.length === 0"
              class="dropdown-item-text text-center py-3"
            >
              <i
                class="fal fa-calendar-times"
                style="font-size: 2rem; color: #ccc;"
              ></i>
              <p class="mt-2 mb-0" style="color: #999;">
                No interviews scheduled
              </p>
            </div>
            <div
              v-for="interview in scheduled_interviews"
              :key="interview.id"
              class="dropdown-item"
              style="border-bottom: 1px solid #e9ecef; padding: 1rem;"
            >
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <strong>{{
                    interview.interview_stage?.stage_name || 'N/A'
                  }}</strong
                  ><br />
                  <small class="text-muted">{{
                    interview.interview_type
                  }}</small
                  ><br />
                  <small class="text-muted">{{
                    formatInterviewDate(interview.interview_date)
                  }}</small
                  ><br />
                  <small class="text-muted"
                    >{{ interview.start_time }} -
                    {{ interview.end_time }}</small
                  >
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-link p-0"
                    type="button"
                    :id="'interviewMenu' + interview.id"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fal fa-ellipsis-v"></i>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    :aria-labelledby="'interviewMenu' + interview.id"
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="viewInterviewDetails(interview)"
                      ><i class="fal fa-eye mr-2"></i>View Details</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="editInterview(interview)"
                      ><i class="fal fa-edit mr-2"></i>Edit</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="updateInterviewStatusDialog(interview)"
                      ><i class="fal fa-flag mr-2"></i>Update Status</a
                    >
                    <div class="dropdown-divider"></div>
                    <a
                      class="dropdown-item text-danger"
                      href="#"
                      @click.prevent="deleteInterview(interview)"
                      ><i class="fal fa-trash mr-2"></i>Delete</a
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="interview.candidates && interview.candidates.length > 0"
                class="mt-2"
              >
                <small class="text-muted"
                  >Candidates: {{ interview.candidates.length }}</small
                >
              </div>
            </div>
          </div>
        </div>

        <div style="margin: auto"></div>
        <div class="header-part-right pr-5">
          <div class="dropdown animate__animated animate__fadeIn">
            <i
              @click="$router.push({ name: 'Onboarding' })"
              style="cursor: pointer; font-size: 120%; position: relative; top: 2px;"
              class="i-Close mr-1"
            ></i>
          </div>
          <!-- Notification End -->
          <!-- User avatar dropdown -->
        </div>
      </div>
      <!-- ======== Body content start ========= -->
      <div
        class="main-content"
        :class="
          $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
            ? 'px-0'
            : null
        "
      >
        <div class="breadcrumb" style="margin-top: 1rem; margin-left: 1rem;">
          <h1>Candidate Details <sup>(Uneditable)</sup></h1>
        </div>
        <v-form @submit.prevent>
          <div class="container-fluid">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">First Name</span>
                <v-text-field
                  v-model="formData.firstname"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.firstname"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Last Name</span>
                <v-text-field
                  v-model="formData.lastname"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.lastname"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Date of Birth</span>
                <v-text-field
                  v-model="formData.dob"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.dob"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Gender</span>
                <v-text-field
                  v-model="formData.sex"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.sex"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">E-mail Address</span>
                <v-text-field
                  v-model="formData.email"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Phone Number</span>
                <v-text-field
                  v-model="formData.phone"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Official Email</span>
                <v-text-field
                  v-model="formData.officialEmail"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.officialEmail"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div class="breadcrumb" style="margin-top: 1rem; margin-left: 1rem;">
          <h1>Address Details</h1>
        </div>
        <v-form @submit.prevent>
          <div class="container-fluid">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Address</span>
                <v-text-field
                  v-model="formData.address"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">State</span>
                <v-text-field
                  v-model="formData.state"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.state"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">City</span>
                <v-text-field
                  v-model="formData.city"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.city"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Country</span>
                <v-text-field
                  v-model="formData.country"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.country"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div class="breadcrumb" style="margin-top: 1rem; margin-left: 1rem;">
          <h1>Professional Details</h1>
        </div>
        <v-form @submit.prevent>
          <div class="container-fluid">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Years of Experience</span>
                <v-text-field
                  v-model="formData.experience"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.experience"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Current Salary</span>
                <v-text-field
                  v-model="formData.salary"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.salary"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="6">
                <span style="color: #111d5e;">Source of Hire</span>
                <v-text-field
                  v-model="formData.sourceOfHire"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Highest Qualification</span>
                <v-text-field
                  v-model="formData.highestQualification"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.highestQualification"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Skill Set</span>
                <v-textarea
                  v-model="formData.skillSet"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.skillSet"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Additional Information</span>
                <v-textarea
                  v-model="formData.additionalInformation"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.additionalInformation"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div class="breadcrumb" style="margin-top: 1rem; margin-left: 1rem;">
          <h1>Personal Details</h1>
        </div>
        <v-form @submit.prevent>
          <div class="container-fluid">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Father's Name</span>
                <v-text-field
                  v-model="formData.fathers_name"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.fathers_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Mother's Name</span>
                <v-text-field
                  v-model="formData.mothers_name"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.mothers_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <span style="color: #111d5e;">Spouse's Name</span>
                <v-text-field
                  v-model="formData.spouses_name"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.spouses_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Blood Group</span>
                <v-text-field
                  v-model="formData.blood_group"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.blood_group"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div class="breadcrumb" style="margin-top: 1rem; margin-left: 1rem;">
          <h1>Guarantor Details</h1>
        </div>
        <v-form @submit.prevent>
          <div class="container-fluid">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Guarantor First Name</span>
                <v-text-field
                  v-model="formData.guarantor_frist_Name"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.guarantor_frist_Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Guarantor Last Name</span>
                <v-text-field
                  v-model="formData.guarantor_last_Name"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.guarantor_last_Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Guarantor E-mail Address</span>
                <v-text-field
                  v-model="formData.guarantor_email"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.guarantor_email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Guarantor Address</span>
                <v-text-field
                  v-model="formData.guarantor_address"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.guarantor_address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Guarantor Phone Number</span>
                <v-text-field
                  v-model="formData.guarantor_phone_number"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.guarantor_phone_number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;"
                  >Candidate-Guarantor Relationship</span
                >
                <v-text-field
                  v-model="formData.employee_grelationship"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.employee_grelationship"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div class="breadcrumb" style="margin-top: 1rem; margin-left: 1rem;">
          <h1>Payment Details</h1>
        </div>
        <v-form @submit.prevent>
          <div class="container-fluid">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Basic Salary</span>
                <v-text-field
                  v-model="formData.basic_salary"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  type="number"
                  :disabled="cannotEdit.basic_salary"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Account Number</span>
                <v-text-field
                  v-model="formData.account_number"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.account_number"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Bank Name</span>
                <v-text-field
                  v-model="formData.bank_name"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.bank_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="remove-hint">
                <span style="color: #111d5e;">Payment Method</span>
                <v-text-field
                  v-model="formData.payment_method"
                  placeholder="Unspecified"
                  solo
                  class="mt-2"
                  :disabled="cannotEdit.payment_method"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>

        <div
          class="breadcrumb row"
          style="margin-top: 1rem; margin-left: 1rem;"
        >
          <h1 class="col-11 px-0 py-0">Education</h1>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="text-left">School Name</th>
                <th scope="col" class="text-left">Degree/Diploma</th>
                <th scope="col" class="text-left">Field(s) of Study</th>
                <th scope="col" class="text-left">Date of Completion</th>
                <th scope="col" class="text-left">Additional Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(education, index) in candidateSpecificEducation"
                :key="index"
              >
                <td>
                  <v-text-field
                    v-model="education.school_name"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="education.degree_diploma"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="education.field_of_study"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="education.date_of_completion"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="education.additional_notes"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="breadcrumb row"
          style="margin-top: 1rem; margin-left: 1rem;"
        >
          <h1 class="col-11 px-0 py-0">Experience</h1>
        </div>
        <div class="table-responsive pb-4">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="text-left">Occupation</th>
                <th scope="col" class="text-left">Company</th>
                <th scope="col" class="text-left">Summary</th>
                <th scope="col" class="text-left">Duration</th>
                <th scope="col" class="text-left">Currently Work Here</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(experience, index) in candidateSpecificExperience"
                :key="index"
              >
                <td>
                  <v-text-field
                    v-model="experience.occupation"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="experience.company"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="experience.summary"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="experience.duration"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="experience.currently_work_here"
                    solo
                    class="educationField mt-2"
                    :disabled="true"
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="flex-grow-1"></div>
      <div
        class="main-header pl-5"
        style="position: fixed; bottom: 0px; z-index: 60;"
      >
        <div class="row">
          <div class="logo col-md-4 py-0">
            <div class="dropdown">
              <button
                type="button"
                class="btn btn-outline-secondary m-1 ripple"
                @click="$router.push({ name: 'Onboarding' })"
              >
                Close
              </button>
            </div>
          </div>
        </div>
        <div style="margin: auto"></div>
        <div class="header-part-right pr-5">
          <!-- Notificaiton End -->
          <!-- User avatar dropdown -->
        </div>
      </div>
      <!-- fotter end -->
    </div>

    <!-- Interview Scheduling Modal -->
    <v-dialog v-model="schedule_interview_dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title
          style="background: linear-gradient(45deg, #17a2b8, #138496); color: white; border-radius: 15px 15px 0 0;"
        >
          <span class="headline">
            <i class="fal fa-calendar-plus mr-2"></i
            >{{ edit_mode ? 'Edit Interview' : 'Schedule Interview' }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form @submit.prevent>
              <div class="container-fluid">
                <v-row>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Interview Type
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-select
                      v-model="interview_form.interview_type"
                      :items="['virtual', 'physical']"
                      placeholder="Select interview type"
                      solo
                      dense
                      class="mt-2"
                      @change="onInterviewTypeChange"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Job Position (Optional)
                    </span>
                    <v-select
                      v-model="interview_form.job_id"
                      :items="auth_created_jobs"
                      item-text="job_title"
                      item-value="id"
                      placeholder="Select a job (optional)"
                      solo
                      dense
                      class="mt-2"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Interview Stage
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-select
                      v-model="interview_form.interview_stage"
                      :items="interview_stages"
                      item-text="stage_name"
                      item-value="id"
                      placeholder="Select interview stage"
                      solo
                      dense
                      class="mt-2"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Interview Date
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-datetime-picker
                      v-model="interview_form.interview_date"
                      label="Select interview date"
                      solo
                      dense
                      class="mt-2"
                    ></v-datetime-picker>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Start Time
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="interview_form.start_time"
                      type="time"
                      placeholder="HH:MM"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >End Time
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="interview_form.end_time"
                      type="time"
                      placeholder="HH:MM"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="interview_form.interview_type === 'virtual'"
                    cols="12"
                    sm="12"
                    md="12"
                    class="remove-hint"
                  >
                    <span style="color: #111d5e; font-weight: 600;"
                      >Meeting Link
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-text-field
                      v-model="interview_form.meeting_link"
                      placeholder="Enter meeting link (Zoom, Teams, etc.)"
                      solo
                      dense
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="interview_form.interview_type === 'physical'"
                    cols="12"
                    sm="12"
                    md="12"
                    class="remove-hint"
                  >
                    <span style="color: #111d5e; font-weight: 600;"
                      >Address
                      <i
                        class="fal fa-asterisk"
                        style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"
                      ></i>
                    </span>
                    <v-textarea
                      v-model="interview_form.address"
                      placeholder="Enter interview address"
                      solo
                      dense
                      rows="3"
                      class="mt-2"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Comments (Optional)</span
                    >
                    <v-textarea
                      v-model="interview_form.comments"
                      placeholder="Add any additional notes for the interview"
                      solo
                      dense
                      rows="2"
                      class="mt-2"
                    ></v-textarea>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    offset-md="3"
                    offset-sm="3"
                    class="remove-hint"
                  >
                    <button
                      @click="
                        schedule_interview_submit
                          ? null
                          : edit_mode
                          ? updateInterview()
                          : schedule_interview()
                      "
                      style="width: 100%; background: linear-gradient(45deg, #28a745, #20c997); border: none; box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3); transition: all 0.3s ease;"
                      type="button"
                      class="btn m-1 text-white btn-raised ripple"
                      onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(40, 167, 69, 0.4)'"
                      onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(40, 167, 69, 0.3)'"
                    >
                      <i class="fal fa-calendar-plus mr-2"></i
                      >{{ schedule_interview_text }}
                      <v-icon
                        :style="
                          !schedule_interview_submit
                            ? 'display: none;'
                            : 'color: #fff; padding: 0px 10px; font-size: 16px;'
                        "
                      >
                        fal fa-circle-notch fa-spin
                      </v-icon>
                    </button>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                    offset-md="3"
                    offset-sm="3"
                    class="remove-hint"
                  >
                    <button
                      @click="sync_to_google_calendar()"
                      style="width: 100%; background: linear-gradient(45deg, #4285f4, #3367d6); border: none; box-shadow: 0 4px 8px rgba(66, 133, 244, 0.3); transition: all 0.3s ease;"
                      type="button"
                      class="btn m-1 text-white btn-raised ripple"
                      onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 12px rgba(66, 133, 244, 0.4)'"
                      onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 8px rgba(66, 133, 244, 0.3)'"
                    >
                      <i class="fab fa-google mr-2"></i>Sync to Google Calendar
                    </button>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeInterviewDialog()">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Update Interview Status Dialog -->
    <v-dialog v-model="update_status_dialog" max-width="500px">
      <v-card>
        <v-card-title
          style="background: linear-gradient(45deg, #6c757d, #5a6268); color: white; border-radius: 15px 15px 0 0;"
        >
          <span class="headline">
            <i class="fal fa-flag mr-2"></i>Update Interview Status
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form @submit.prevent>
              <div class="container-fluid">
                <v-row>
                  <v-col cols="12" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;"
                      >Status</span
                    >
                    <v-select
                      v-model="status_form.status"
                      :items="status_options"
                      placeholder="Select status"
                      solo
                      dense
                      class="mt-2"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" class="remove-hint">
                    <span style="color: #111d5e; font-weight: 600;">Notes</span>
                    <v-textarea
                      v-model="status_form.notes"
                      placeholder="Add notes"
                      solo
                      dense
                      rows="3"
                      class="mt-2"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="update_status_dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="updateCandidateStatus()">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/main';
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      formData: {
        email: '',
        phone: '',
        firstname: '',
        lastname: '',
        dob: '',
        sex: '',
        officialEmail: '',
        address: '',
        state: '',
        city: '',
        country: '',
        experience: '',
        salary: '',
        sourceOfHire: '',
        skillSet: '',
        highestQualification: '',
        additionalInformation: '',
        fathers_name: '',
        mothers_name: '',
        spouses_name: '',
        blood_group: '',
        guarantor_frist_Name: '',
        guarantor_last_Name: '',
        guarantor_email: '',
        guarantor_address: '',
        guarantor_phone_number: '',
        employee_grelationship: '',
        basic_salary: '',
        account_number: '',
        bank_name: '',
        payment_method: '',
      },
      cannotEdit: {
        email: true,
        phone: true,
        firstname: true,
        lastname: true,
        dob: true,
        sex: true,
        officialEmail: true,
        streetAddress: true,
        state: true,
        city: true,
        country: true,
        experience: true,
        salary: true,
        sourceOfHire: true,
        skillSet: true,
        highestQualification: true,
        additionalInformation: true,
        fathers_name: true,
        mothers_name: true,
        spouses_name: true,
        blood_group: true,
        guarantor_frist_Name: true,
        guarantor_last_Name: true,
        guarantor_email: true,
        guarantor_address: true,
        guarantor_phone_number: true,
        employee_grelationship: true,
        basic_salary: true,
        account_number: true,
        bank_name: true,
        payment_method: true,
      },
      sourceOfHire: [
        'Direct',
        'Newspaper',
        'Advertisement',
        'Employee Referral',
        'External Referral',
      ],
      work_here: ['Yes', 'No'],
      allEducation: [],
      allWorkExperience: [],
      candidateSpecificEducation: [],
      candidateSpecificExperience: [],
      // Interview scheduling data
      schedule_interview_dialog: false,
      schedule_interview_submit: false,
      schedule_interview_text: 'Schedule Interview',
      update_status_dialog: false,
      interview_stages: [],
      scheduled_interviews: [],
      edit_mode: false,
      editing_interview_id: null,
      current_interview_candidate: null,
      status_form: {
        candidate_id: null,
        status: '',
        notes: '',
      },
      status_options: ['scheduled', 'completed', 'rescheduled', 'cancelled'],
      interview_form: {
        interview_type: '',
        interview_stage: null,
        interview_date: null,
        start_time: '',
        end_time: '',
        meeting_link: '',
        address: '',
        comments: '',
        calendar_sync: 'google',
        job_id: null,
        stage_id: null,
      },
      triggerOnboardingLoading: false,
      triggerOnboardingTxt: 'Trigger Onboarding',
    };
  },
  computed: {
    ...mapGetters([
      'validEmployeeId',
      'authCompanyData',
      'authCompanyCandidates',
      'auth_created_jobs',
    ]),
    candidate() {
      let _this = this;
      return _this.authCompanyCandidates.filter((candidate) => {
        return candidate.id == parseInt(_this.$route.params.id);
      })[0];
    },
  },
  methods: {
    ...mapActions(['fetch_candidates', 'fetch_all_company_jobs']),
    fileTrigger() {
      document.querySelector('.staffUploadInput div div div input').click();
    },
    fileTrigger2() {
      document.querySelector('.staffUploadInput2 div div div input').click();
    },
    trigger_onboarding() {
      let _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      _this.triggerOnboardingTxt = '';
      _this.triggerOnboardingLoading = true;

      axios
        .post(
          `${BASE_URL}triggeronboarding`,
          {
            candidate_ids: [_this.candidate.id],
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        )
        .then(function() {
          Toast.fire({
            icon: 'success',
            title: 'Onboarding process triggered successfully',
          });
        })
        .catch(function(error) {
          const msg =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            'Failed to trigger onboarding process';
          Toast.fire({
            icon: 'error',
            title: msg,
          });
          console.log(error.response || error);
        })
        .then(function() {
          _this.triggerOnboardingLoading = false;
          _this.triggerOnboardingTxt = 'Trigger Onboarding';
        });
    },
    fetch_interview_stages() {
      const _this = this;
      const token = localStorage.getItem('userToken');

      window.axios
        .get(`https://apiqa.kylianerp.com/api/interviewstages`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(function(response) {
          _this.interview_stages = response.data.data || [];
        })
        .catch(function(error) {
          console.log('Error fetching interview stages:', error);
        });
    },
    fetch_scheduled_interviews() {
      const _this = this;
      const token = localStorage.getItem('userToken');

      window.axios
        .get(`https://apiqa.kylianerp.com/api/interviews`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(function(response) {
          // Filter interviews that include this candidate
          const candidateId = _this.candidate.id;
          _this.scheduled_interviews = (response.data.data || []).filter(
            (interview) => {
              return (
                interview.candidates &&
                interview.candidates.some((c) => c.id === candidateId)
              );
            }
          );
        })
        .catch(function(error) {
          console.log('Error fetching scheduled interviews:', error);
        });
    },
    schedule_interview() {
      const _this = this;
      const token = localStorage.getItem('userToken');
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      // Validation
      if (
        !_this.interview_form.interview_type ||
        !_this.interview_form.interview_stage ||
        !_this.interview_form.interview_date ||
        !_this.interview_form.start_time ||
        !_this.interview_form.end_time
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please fill all required fields',
        });
        return;
      }

      if (
        _this.interview_form.interview_type === 'virtual' &&
        !_this.interview_form.meeting_link
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please provide meeting link for virtual interview',
        });
        return;
      }

      if (
        _this.interview_form.interview_type === 'physical' &&
        !_this.interview_form.address
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please provide address for physical interview',
        });
        return;
      }

      _this.schedule_interview_submit = true;
      _this.schedule_interview_text = '';

      const interviewDate = new Date(_this.interview_form.interview_date);
      const formattedDate = interviewDate.toISOString().split('T')[0];

      const payload = {
        job_id: _this.interview_form.job_id || 1,
        stage_id: _this.interview_form.interview_stage,
        interview_type: _this.interview_form.interview_type,
        interview_date: formattedDate,
        start_time: _this.interview_form.start_time,
        end_time: _this.interview_form.end_time,
        meeting_link:
          _this.interview_form.interview_type === 'virtual'
            ? _this.interview_form.meeting_link
            : null,
        address:
          _this.interview_form.interview_type === 'physical'
            ? _this.interview_form.address
            : null,
        comments: _this.interview_form.comments,
        calendar_sync: _this.interview_form.calendar_sync,
        candidate_ids: [_this.candidate.id],
      };

      window.axios
        .post(`https://apiqa.kylianerp.com/api/interviews`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(function() {
          Toast.fire({
            icon: 'success',
            title: 'Interview scheduled successfully',
          });
          _this.schedule_interview_dialog = false;
          _this.fetch_scheduled_interviews();
          _this.reset_interview_form();
        })
        .catch(function(error) {
          let errors = error.response?.data?.error || null;
          Toast.fire({
            icon: 'error',
            title: errors
              ? typeof errors === 'string'
                ? errors
                : null || errors.interview_type
                ? errors.interview_type[0]
                : null || errors.start_time
                ? errors.start_time[0]
                : null
              : null ||
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Failed to schedule interview',
          });
        })
        .then(function() {
          _this.schedule_interview_submit = false;
          _this.schedule_interview_text = 'Schedule Interview';
        });
    },
    reset_interview_form() {
      this.interview_form = {
        interview_type: '',
        interview_stage: null,
        interview_date: null,
        start_time: '',
        end_time: '',
        meeting_link: '',
        address: '',
        comments: '',
        calendar_sync: 'google',
        job_id: null,
        stage_id: null,
      };
    },
    onInterviewTypeChange() {
      // Clear meeting link or address when interview type changes
      if (this.interview_form.interview_type === 'virtual') {
        this.interview_form.address = '';
      } else if (this.interview_form.interview_type === 'physical') {
        this.interview_form.meeting_link = '';
      }
    },
    formatInterviewDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    closeInterviewDialog() {
      this.schedule_interview_dialog = false;
      this.edit_mode = false;
      this.editing_interview_id = null;
      this.reset_interview_form();
    },
    viewInterviewDetails(interview) {
      // Show interview details in an alert or modal
      const details = `
        Stage: ${interview.interview_stage?.stage_name || 'N/A'}
        Type: ${interview.interview_type}
        Date: ${this.formatInterviewDate(interview.interview_date)}
        Time: ${interview.start_time} - ${interview.end_time}
        ${
          interview.interview_type === 'virtual'
            ? `Meeting Link: ${interview.meeting_link}`
            : `Address: ${interview.address}`
        }
        Comments: ${interview.comments || 'None'}
      `;
      this.$swal.fire({
        title: 'Interview Details',
        html: `<pre style="text-align: left; white-space: pre-wrap;">${details}</pre>`,
        icon: 'info',
      });
    },
    editInterview(interview) {
      this.edit_mode = true;
      this.editing_interview_id = interview.id;
      this.interview_form.interview_type = interview.interview_type;
      this.interview_form.interview_stage = interview.stage_id;
      this.interview_form.interview_date = interview.interview_date;
      this.interview_form.start_time = interview.start_time;
      this.interview_form.end_time = interview.end_time;
      this.interview_form.meeting_link = interview.meeting_link || '';
      this.interview_form.address = interview.address || '';
      this.interview_form.comments = interview.comments || '';
      this.interview_form.job_id = interview.job_id;
      this.schedule_interview_text = 'Update Interview';
      this.schedule_interview_dialog = true;
    },
    updateInterview() {
      const _this = this;
      const token = localStorage.getItem('userToken');
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      _this.schedule_interview_submit = true;
      _this.schedule_interview_text = '';

      const interviewDate = new Date(_this.interview_form.interview_date);
      const formattedDate = interviewDate.toISOString().split('T')[0];

      const payload = {
        job_id: _this.interview_form.job_id,
        stage_id: _this.interview_form.interview_stage,
        interview_type: _this.interview_form.interview_type,
        interview_date: formattedDate,
        start_time: _this.interview_form.start_time,
        end_time: _this.interview_form.end_time,
        meeting_link:
          _this.interview_form.interview_type === 'virtual'
            ? _this.interview_form.meeting_link
            : null,
        address:
          _this.interview_form.interview_type === 'physical'
            ? _this.interview_form.address
            : null,
        comments: _this.interview_form.comments,
        calendar_sync: _this.interview_form.calendar_sync,
      };

      window.axios
        .put(
          `https://apiqa.kylianerp.com/api/interviews/${_this.editing_interview_id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function() {
          Toast.fire({
            icon: 'success',
            title: 'Interview updated successfully',
          });
          _this.schedule_interview_dialog = false;
          _this.fetch_scheduled_interviews();
          _this.reset_interview_form();
          _this.edit_mode = false;
          _this.editing_interview_id = null;
        })
        .catch(function(error) {
          Toast.fire({
            icon: 'error',
            title:
              error.response?.data?.message || 'Failed to update interview',
          });
        })
        .then(function() {
          _this.schedule_interview_submit = false;
          _this.schedule_interview_text = 'Schedule Interview';
        });
    },
    updateInterviewStatusDialog(interview) {
      this.current_interview = interview;
      this.status_form.candidate_id = interview.candidates?.[0]?.id || null;
      this.update_status_dialog = true;
    },
    updateCandidateStatus() {
      const _this = this;
      const token = localStorage.getItem('userToken');
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      if (!_this.status_form.status) {
        Toast.fire({
          icon: 'error',
          title: 'Please select a status',
        });
        return;
      }

      window.axios
        .patch(
          `https://apiqa.kylianerp.com/api/interviews/candidates/${_this.status_form.candidate_id}/status`,
          {
            status: _this.status_form.status,
            notes: _this.status_form.notes,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function() {
          Toast.fire({
            icon: 'success',
            title: 'Status updated successfully',
          });
          _this.update_status_dialog = false;
          _this.status_form = {
            candidate_id: null,
            status: '',
            notes: '',
          };
          _this.fetch_scheduled_interviews();
        })
        .catch(function(error) {
          Toast.fire({
            icon: 'error',
            title: error.response?.data?.message || 'Failed to update status',
          });
        });
    },
    deleteInterview(interview) {
      const _this = this;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: 'You want to delete this interview?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            const token = localStorage.getItem('userToken');
            window.axios
              .delete(
                `https://apiqa.kylianerp.com/api/interviews/${interview.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then(function() {
                _this.$swal.fire(
                  'Deleted!',
                  'Interview has been deleted.',
                  'success'
                );
                _this.fetch_scheduled_interviews();
              })
              .catch(function(error) {
                _this.$swal.fire(
                  'Error!',
                  error.response?.data?.message || 'Failed to delete interview',
                  'error'
                );
              });
          }
        });
    },
    sync_to_google_calendar() {
      const _this = this;
      const Toast = _this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', _this.$swal.stopTimer);
          toast.addEventListener('mouseleave', _this.$swal.resumeTimer);
        },
      });

      // Validation
      if (
        !_this.interview_form.interview_date ||
        !_this.interview_form.start_time ||
        !_this.interview_form.end_time
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please fill interview date and time first',
        });
        return;
      }

      const interviewDate = new Date(_this.interview_form.interview_date);
      const formattedDate = interviewDate.toISOString().split('T')[0];

      // Format dates for Google Calendar
      const startDateTime = `${formattedDate}T${_this.interview_form.start_time}:00`;
      const endDateTime = `${formattedDate}T${_this.interview_form.end_time}:00`;

      const eventTitle = `Interview - ${_this.candidate.employee_fristname} ${_this.candidate.employee_lastname}`;
      const location =
        _this.interview_form.interview_type === 'physical'
          ? _this.interview_form.address
          : _this.interview_form.meeting_link || 'Virtual Interview';

      const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
        eventTitle
      )}&dates=${encodeURIComponent(
        startDateTime + '/' + endDateTime
      )}&details=${encodeURIComponent(
        _this.interview_form.comments || 'Interview scheduled via Kylian ERP'
      )}&location=${encodeURIComponent(location)}`;

      // Open Google Calendar in new tab
      window.open(googleCalendarUrl, '_blank');

      Toast.fire({
        icon: 'success',
        title: 'Opening Google Calendar...',
      });
    },
  },
  mounted() {
    document.title = 'Kylian ERP - View Candidate';
    let _this = this;

    // Fetch interview data
    this.fetch_interview_stages();
    this.fetch_scheduled_interviews();
    this.fetch_all_company_jobs();

    this.formData.email = this.candidate.employee_email;
    this.formData.firstname = this.candidate.employee_fristname;
    this.formData.phone = this.candidate.employee_phone1;
    this.formData.lastname = this.candidate.employee_lastname;
    this.formData.dob = this.candidate.employee_date_of_birth;
    this.formData.sex = this.candidate.employee_sex;
    this.formData.officialEmail = this.candidate.employee_officialemail;
    this.formData.address = this.candidate.employee_address;
    this.formData.state = this.candidate.employee_state;
    this.formData.country = this.candidate.employee_nationality;
    this.formData.experience = this.candidate.experience;
    this.formData.salary = this.candidate.current_salary;
    this.formData.sourceOfHire = this.candidate.source_of_hire;
    this.formData.highestQualification = this.candidate.Highest_qualification;
    this.formData.skillSet = this.candidate.skill_set;
    this.formData.additionalInformation = this.candidate.paddtional_info;

    axios
      .post(`${BASE_URL}fetchcandidate`, {
        company_id: _this.authCompanyData.id,
      })
      .then(function(response) {
        const RESPONSE = response.data;
        console.log(RESPONSE);
        _this.allWorkExperience = RESPONSE.Work_experience;
        _this.allEducation = RESPONSE.Education;
        let tempEducation = _this.allEducation.filter((edu) => {
          return edu.employee_id == _this.candidate.id;
        });
        if (tempEducation.length) {
          _this.candidateSpecificEducation = tempEducation.map((edu) => {
            return {
              id: edu.id,
              company_id: edu.company_id,
              company_unique_id: edu.company_unique_id,
              school_name: edu.school_name,
              degree_diploma: edu.degree_diploma,
              field_of_study: edu.field_of_study,
              date_of_completion: edu.date_of_completion,
              additional_notes: edu.additional_notes,
              employee_id: edu.employee_id,
              created_at: edu.created_at,
              updated_at: edu.updated_at,
              viewOption: false,
            };
          });
        } else {
          _this.candidateSpecificEducation.push({
            id: null,
            company_id: '',
            company_unique_id: '',
            school_name: '',
            degree_diploma: '',
            field_of_study: '',
            date_of_completion: '',
            additional_notes: '',
            employee_id: '',
            created_at: '',
            updated_at: '',
            viewOption: false,
          });
        }
        let tempExperience = _this.allWorkExperience.filter((exp) => {
          return exp.employee_id == _this.candidate.id;
        });
        if (tempExperience.length) {
          _this.candidateSpecificExperience = tempExperience.map((exp) => {
            return {
              company: exp.company,
              company_id: exp.company_id,
              company_unique_id: exp.company_unique_id,
              created_at: exp.created_at,
              currently_work_here: exp.currently_work_here,
              duration: exp.duration,
              employee_id: exp.employee_id,
              field_of_study: exp.field_of_study,
              id: exp.id,
              occupation: exp.occupation,
              summary: exp.summary,
              updated_at: exp.updated_at,
              viewOption: false,
            };
          });
        } else {
          _this.candidateSpecificExperience.push({
            id: null,
            company: '',
            company_id: '',
            company_unique_id: '',
            created_at: '',
            currently_work_here: '',
            duration: '',
            employee_id: '',
            field_of_study: '',
            occupation: '',
            summary: '',
            updated_at: '',
            viewOption: false,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // context.commit('AUTH_FETCHED_EMPLOYEES', );
      });
  },
};
</script>

<style>
.remove-hint div div div.v-text-field__details {
  display: none !important;
}

.educationField .v-text-field__details {
  display: none !important;
}

.educationField .v-input__slot {
  margin: 0;
}
</style>
